define('viewmodels/pages/playOkay',['underscore', 'knockout', 'plugins/dialog'], function(_, ko, dialog) {

    var createPlayOkayContentBlock = function(block) {
        var intro = _.isEqual(block.intro, 'empty') ? '' : block.intro;
        var items = ko.observableArray();

        // Replace the 'empty'  marker with an actually empty sting.
        // In case of empty links we remove the complete item.
        _.forEach(block.items, function(item) {
            if(_.isEqual(item.text, 'empty')) {
                item.text = '';
            }
            /* jshint ignore:start */
            if(!_.isEqual(item.link_text, 'empty')) {
                items.push(item);
            }
            /* jshint ignore:end */
        });

        return {
            title: ko.observable(block.title),
            items: items,
            contentType: ko.observable(block.contentType),
            intro: ko.observable(intro)
        };
    };


    return function PlayOkayViewModel(playOkayPageField, PlayOkayDialog) {
        var self = this;
        self.topBar = ko.observable();
        self.title = playOkayPageField('title');
        self.text = playOkayPageField('text');
        self.mobileLogo = playOkayPageField('play_okay_mobile_logo');
        self.tabletLogo = playOkayPageField('play_okay_tablet_logo');
        self.topics = ko.pureComputed(function() {
            var topics = playOkayPageField('topics')();

            if (!_.some(topics)) {
                return [];
            }
            return _.map(topics, createPlayOkayContentBlock);
        });
        self.subNav = {
            name: 'playokay',
            tabs: ko.observableArray()
        };
        self.showPlayOkayDialog = function(block) {
            dialog.showDialog(new PlayOkayDialog(block));
        };

    };
});

